export default {
  setCountriesList(state, data) {
    state.countries = data;
  },
  setStatesList(state, data) {
    state.states = data;
  },
};
